import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { CreateTranslatedTemplatesResponseData, CreateTranslatedTemplatesSchema } from "schema"
import z from "zod"

export const useCreateTranslatedTemplatesMutation = () => {
  return useMutation({
    mutationFn: async (
      payload: z.input<typeof CreateTranslatedTemplatesSchema> & { id: string },
    ) => {
      const { data } = await axios.post<{
        data: z.infer<typeof CreateTranslatedTemplatesResponseData>
      }>(`/integrations/whatsapp/templates/translation`, payload)
      return data.data
    },
  })
}
